import React from "react";
import { Box, Flex, Stack, Text } from "@chakra-ui/layout";
import {
  useColorModeValue,
  VStack,
  Link,
  theme,
  Tag,
  Wrap,
  WrapItem, Grid
} from "@chakra-ui/react";
import { useSession } from "next-auth/client";
import ThreadTweet from "./threadTweet";
import { getAccount } from "../../../utils/sessionHelper";
import { AiOutlineRetweet, AiOutlineBell } from "react-icons/ai";
import { MdLeaderboard } from "react-icons/md";
import { SiGhostery, SiLinkedin } from "react-icons/si";
import { BiTimeFive } from "react-icons/bi";
import dateFormat from 'dateformat';

const Tweet = ({
  threadTweets,
  image = undefined,
  name = undefined,
  tweet = undefined as any,
  showOutline = false,
  mode = "tweet",
  disablePreview = false,
  selectTweetInThread = undefined as any,
  showGenerateImage = false,
  ...rest
}) => {

  const [session, loading] = useSession();
  const tweetLabels = getAccount(session)?.tweetLabels;

  const buildReminders = () => {

    let nbReminders = 0;

    let isPreventLinkExpand = false;
    let isAutoRetweet = false;
    let isAutoPlug = false;
    let isDelayBetweenTweets = false;
    let isAutoDm = false;
    let dmString = "";
    let isAutoRtWithOtherAccounts = false;
    let isLiveTweet = false;
    let selectedLabels: any[] = [];

    if (tweet?.isPreventLinkExpand && tweet.text.includes("http")) {
      isPreventLinkExpand = true;
      nbReminders++;
    }
    if (tweet?.isAutoRetweet) {
      isAutoRetweet = true;
      nbReminders++;
    }
    if (tweet?.isAutoPlug) {
      isAutoPlug = true;
      nbReminders++;
    }
    if (tweet?.isDelayBetweenTweets && threadTweets?.length > 1) {
      isDelayBetweenTweets = true;
      nbReminders++;
    }
    if (tweet?.isAutoDm) {
      isAutoDm = true;
      nbReminders++;
      let triggers = [] as any;
      if (tweet?.autoDmTrigger?.retweet) triggers.push("retweet");
      if (tweet?.autoDmTrigger?.reply) triggers.push("reply");
      if (tweet?.autoDmTrigger?.like) triggers.push("like");
      dmString = triggers.join(" or ");
    }
    if (tweet?.ghostwriterTwUserName) {
      nbReminders++;
    }
    if (tweet?.autoRtWithOtherAccounts) {
      isAutoRtWithOtherAccounts = true;
      nbReminders++;
    }
    if (tweet?.isLiveTweet) {
      isLiveTweet = true;
      nbReminders++;
    }
    if (tweet?.isPushTaplio) {
      nbReminders++;
    }
    if (tweet?.isNotifyFanList) {
      nbReminders++;
    }
    if (tweet?.labels?.length > 0) {
      selectedLabels = tweetLabels?.filter(tl => tweet?.labels?.includes(tl.id));
      nbReminders++;
    }

    if (nbReminders > 0)
      return (
        <Stack mt={8} mb={5} w="full" spacing="4">
          {
            isPreventLinkExpand && (
              <Grid gridTemplateColumns={"16px 1fr"} gap={2} textStyle="body.medium.light" alignItems={"center"}>
                <svg width="16" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.40625 4.125C7.15625 2.375 10 2.375 11.75 4.125C13.4375 5.78125 13.5 8.46875 11.9688 10.25L11.7812 10.4375C11.5 10.75 11.0312 10.7812 10.7188 10.5312C10.4062 10.25 10.375 9.78125 10.6562 9.46875L10.8125 9.28125C11.875 8.09375 11.8125 6.3125 10.6875 5.1875C9.53125 4 7.625 4 6.4375 5.1875L2.90625 8.71875C1.75 9.90625 1.75 11.7812 2.90625 12.9688C4.03125 14.0625 5.8125 14.125 7 13.0938L7.1875 12.9375C7.5 12.6562 7.96875 12.6875 8.25 13C8.53125 13.3125 8.5 13.7812 8.1875 14.0625L8 14.2188C6.21875 15.7812 3.53125 15.6875 1.84375 14.0312C0.09375 12.2812 0.09375 9.40625 1.84375 7.65625L5.40625 4.125ZM14.5938 11.9062C12.8125 13.6562 9.96875 13.6562 8.21875 11.9062C6.53125 10.2188 6.46875 7.5625 8 5.78125L8.15625 5.59375C8.4375 5.28125 8.90625 5.25 9.21875 5.53125C9.53125 5.8125 9.5625 6.28125 9.28125 6.59375L9.15625 6.75C8.09375 7.9375 8.15625 9.71875 9.28125 10.8438C10.4375 12 12.3438 12 13.5312 10.8438L17.0625 7.3125C18.2188 6.125 18.2188 4.25 17.0625 3.0625C15.9375 1.96875 14.1562 1.90625 12.9688 2.9375L12.7812 3.09375C12.4688 3.375 12 3.34375 11.7188 3.03125C11.4375 2.71875 11.4688 2.25 11.7812 1.96875L11.9688 1.8125C13.75 0.25 16.4375 0.34375 18.125 2C19.875 3.75 19.875 6.59375 18.125 8.375L14.5938 11.9062Z" fill="currentColor" />
                </svg>
                URLs will not be expanded</Grid>
            )
          }
          {
            isAutoRetweet && (
              <Grid gridTemplateColumns={"16px 1fr"} gap={2} textStyle="body.medium.light" alignItems={"center"}>
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.25 4.84375L5.96875 7.75C6.0625 8.15625 5.8125 8.5625 5.40625 8.65625C5.34375 8.6875 5.28125 8.6875 5.21875 8.6875C4.90625 8.6875 4.59375 8.46875 4.5 8.125L4.25 7.03125L2.125 10.5625C1.9375 10.875 1.9375 11.25 2.09375 11.5312L2.15625 11.7188C2.34375 12.0625 2.6875 12.25 3.0625 12.25H4.25C4.65625 12.25 5 12.5938 5 13.0312C5 13.4375 4.65625 13.75 4.25 13.75H3.0625C2.125 13.75 1.25 13.2188 0.8125 12.375L0.75 12.2188C0.375 11.4375 0.40625 10.5312 0.84375 9.8125L2.84375 6.4375L1.96875 6.78125C1.5625 6.90625 1.15625 6.71875 1 6.34375C0.84375 5.9375 1.0625 5.5 1.4375 5.375L4.25 4.3125C4.46875 4.25 4.6875 4.25 4.875 4.34375C5.0625 4.4375 5.1875 4.625 5.25 4.84375ZM5.5625 3.40625C5.1875 3.1875 5.09375 2.75 5.28125 2.375L5.8125 1.5C6.28125 0.71875 7.09375 0.25 8 0.25C8.875 0.25 9.6875 0.71875 10.1562 1.5L11.8438 4.3125L12 3.40625C12.0625 3 12.4375 2.71875 12.875 2.8125C13.2812 2.875 13.5312 3.25 13.4688 3.65625L12.9688 6.625C12.9375 6.84375 12.8125 7.03125 12.625 7.15625C12.5 7.21875 12.375 7.25 12.25 7.25C12.1562 7.25 12.0938 7.25 12.0312 7.25L9.125 6.375C8.75 6.28125 8.5 5.84375 8.625 5.46875C8.75 5.0625 9.15625 4.84375 9.5625 4.9375L10.6562 5.28125L8.84375 2.25C8.5 1.65625 7.46875 1.65625 7.125 2.25L6.59375 3.15625C6.375 3.5 5.90625 3.625 5.5625 3.40625ZM15.125 9.8125C15.5625 10.5312 15.5938 11.4375 15.2188 12.2188L15.1562 12.375C14.7188 13.2188 13.8438 13.75 12.9062 13.75H8.96875L9.71875 14.4688C10.0312 14.7188 10.0625 15.2188 9.78125 15.5C9.65625 15.6875 9.4375 15.75 9.25 15.75C9.0625 15.75 8.875 15.6875 8.75 15.5625L6.5 13.5625C6.3125 13.4375 6.25 13.2188 6.25 13C6.25 12.8125 6.3125 12.5938 6.5 12.4688L8.75 10.4688C9.03125 10.1875 9.53125 10.2188 9.8125 10.5312C10.0625 10.8125 10.0312 11.3125 9.75 11.5625L8.96875 12.25H12.9062C13.2812 12.25 13.625 12.0625 13.8125 11.7188L13.875 11.5625C14.0312 11.25 14.0312 10.875 13.8438 10.5625L13.125 9.40625C12.9375 9.03125 13.0312 8.59375 13.4062 8.375C13.75 8.15625 14.2188 8.28125 14.4375 8.625L15.125 9.8125Z" fill="currentColor" />
                </svg>
                Will be auto-retweeted {tweet.autoRetweetTimes > 1 ? tweet.autoRetweetTimes + " times every" : " in"} {tweet.autoRetweetHours} hour{tweet.autoRetweetHours > 1 ? "s" : ""}
              </Grid>
            )
          }
          {
            isAutoPlug && (
              <Box>
                <Grid gridTemplateColumns={"16px 1fr"} gap={2} textStyle="body.medium.light" alignItems={"center"}>
                  <svg width="14" height="14" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.0938 1.625C12.375 3.71875 14 7.15625 14 8.8125C14 12.7812 10.8438 16 7 16C3.125 16 0 12.7812 0 8.8125C0 6.5625 2.15625 2.875 5.25 0C6.4375 1.125 7.5 2.3125 8.34375 3.5C8.875 2.84375 9.4375 2.21875 10.0938 1.625ZM7 14.5C10.0312 14.5 12.5 11.9688 12.5 8.8125C12.5 7.84375 11.5 5.5625 10.0625 3.78125C9.875 4 9.6875 4.21875 9.5 4.4375L8.28125 5.9375L7.125 4.375C6.59375 3.625 5.9375 2.84375 5.25 2.125C2.875 4.65625 1.5 7.40625 1.5 8.8125C1.5 11.9688 3.96875 14.5 7 14.5ZM9.78125 7.625C9.90625 7.8125 10 7.96875 10.0938 8.15625C10.8438 9.59375 10.5312 11.4062 9.1875 12.3438C8.59375 12.7812 7.84375 13 7.0625 13C5.09375 13 3.5 11.7188 3.5 9.59375C3.5 8.53125 4.15625 7.59375 5.46875 6C5.65625 6.21875 8.1875 9.4375 8.1875 9.4375L9.78125 7.625Z" fill="currentColor" />
                  </svg>
                  This tweet will be plugged at {tweet.autoPlugTrigger} likes
                </Grid>
                <Box
                  border="1px"
                  borderColor={useColorModeValue("border.lightMode.light", "border.darkMode.light")}
                  rounded="lg"
                  mt="4"
                  p="4"
                >
                  <ThreadTweet
                    text={tweet.autoPlugText}
                    name={getAccount(session)?.name}
                    image={getAccount(session)?.image}
                    isLast={true}
                    disableNbChar={true}
                    disablePreview={disablePreview}
                    selectTweetInThread={selectTweetInThread}
                    showGenerateImage={showGenerateImage}
                  />
                </Box>
              </Box>
            )
          }
          {
            isDelayBetweenTweets && (
              <Grid gridTemplateColumns={"16px 1fr"} gap={2} textStyle="body.medium.light" alignItems={"center"}>
                <svg width="10" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0.75C0 0.34375 0.3125 0 0.75 0H11.25C11.6562 0 12 0.34375 12 0.75C12 1.1875 11.6562 1.5 11.25 1.5H11V2.09375C11 3.375 10.4688 4.5625 9.59375 5.46875L7.03125 8L9.59375 10.5625C10.4688 11.4375 11 12.6562 11 13.9062V14.5H11.25C11.6562 14.5 12 14.8438 12 15.25C12 15.6875 11.6562 16 11.25 16H0.75C0.3125 16 0 15.6875 0 15.25C0 14.8438 0.3125 14.5 0.75 14.5H1V13.9062C1 12.6562 1.5 11.4375 2.375 10.5625L4.9375 8L2.375 5.46875C1.5 4.5625 1 3.375 1 2.09375V1.5H0.75C0.3125 1.5 0 1.1875 0 0.75ZM3.09375 12H8.875C8.78125 11.875 8.65625 11.75 8.53125 11.625L6 9.0625L3.4375 11.625C3.3125 11.75 3.1875 11.875 3.09375 12ZM8.875 4C9.25 3.46875 9.5 2.8125 9.5 2.09375V1.5H2.5V2.09375C2.5 2.8125 2.71875 3.46875 3.09375 4H8.875Z" fill="currentColor" />
                </svg>

                Each tweet to be posted with a delay of {tweet.delayBetweenTweetsMinutes} minute{tweet.delayBetweenTweetsMinutes > 1 ? "s" : ""}
              </Grid>
            )
          }
          {
            isAutoDm && (
              <Box>
                <Grid gridTemplateColumns={"16px 1fr"} textAlign="left" gap={2} textStyle="body.medium.light" alignItems={"center"}>
                  <svg width="12" height="12" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.9688 0C16.0938 0 16.9688 0.90625 16.9688 2V10.9688C16.9688 12.0312 16.0625 12.9375 14.9688 12.9375H10.4688L6.5625 15.8438C6.3125 16.0312 5.96875 15.875 5.96875 15.5625V12.9375H2.96875C1.84375 12.9375 0.96875 12.0625 0.96875 10.9688V2C0.96875 0.90625 1.84375 0 2.96875 0H14.9688ZM15.5 11V2C15.5 1.75 15.25 1.5 15 1.5H3C2.71875 1.5 2.5 1.75 2.5 2V11C2.5 11.2812 2.71875 11.5 3 11.5H7.5V13.375L10 11.5H15C15.25 11.5 15.5 11.2812 15.5 11Z" fill="currentColor" />
                  </svg>
                  A DM will be sent when people: {dmString}. Max {tweet?.autoDmMax} DMs will be sent.
                </Grid>
                {tweet.isAutoDmRandom && (
                  <Flex textAlign="left" gap={2} textStyle="body.medium.light" alignItems={"center"}>
                    {tweet.autoDmMax} DMs will be sent randomly after 24h
                  </Flex>
                )}
                {tweet.isAutoDmLeadMagnet && (
                  <Flex textAlign="left" gap={2} textStyle="body.medium.light" alignItems={"center"}>
                    A lead magnet link will be plugged to collect emails
                  </Flex>
                )}
                <Box
                  border="1px"
                  borderColor={useColorModeValue("border.lightMode.light", "border.darkMode.light")}
                  rounded="lg"
                  mt="4"
                  p="4"
                >
                  <ThreadTweet
                    text={tweet.autoDmText}
                    name={getAccount(session)?.name}
                    image={getAccount(session)?.image}
                    isLast={true}
                    disableNbChar={true}
                    disablePreview={disablePreview}
                    selectTweetInThread={selectTweetInThread}
                    showGenerateImage={showGenerateImage}
                  />
                </Box>
              </Box>
            )
          }
          {
            isAutoRtWithOtherAccounts && (
              <Grid gridTemplateColumns={"16px 1fr"} alignItems="center" justifyContent="left" textStyle="body.medium.light">
                <svg width="16" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.25 11.5C10.6562 11.5 11 11.8438 11 12.25C11 12.6875 10.6562 13 10.25 13H3.5C3.0625 13 2.75 12.6875 2.75 12.25V6H1C0.6875 6 0.40625 5.84375 0.28125 5.5625C0.1875 5.28125 0.25 4.9375 0.46875 4.75L2.96875 2.25C3.09375 2.09375 3.28125 2 3.5 2C3.6875 2 3.875 2.09375 4 2.21875L6.5 4.75C6.71875 4.9375 6.78125 5.28125 6.6875 5.5625C6.5625 5.84375 6.28125 6 6 6H4.25V11.5H10.25ZM18.6875 10.4688C18.7812 10.75 18.7188 11.0938 18.5 11.2812L16 13.7812C15.875 13.9375 15.6875 14 15.5 14C15.2812 14 15.0938 13.9375 14.9688 13.7812L12.4688 11.2812C12.25 11.0625 12.1875 10.7188 12.2812 10.4375C12.4062 10.1562 12.6875 10 13 10H14.75V4.5H8.75C8.3125 4.5 8 4.1875 8 3.75C8 3.34375 8.3125 3 8.75 3H15.5C15.9062 3 16.25 3.34375 16.25 3.75V10H18C18.2812 10 18.5625 10.1875 18.6875 10.4688Z" fill="currentColor" />
                </svg>

                <Text textAlign="left" ml="2">will be auto retweeted with other accounts</Text>
              </Grid>
            )
          }
          {
            isLiveTweet && (
              <Grid gridTemplateColumns={"16px 1fr"} alignItems="center" justifyContent="left" gap={2} textStyle="body.medium.light">
                <MdLeaderboard />
                <Text textAlign="center" >A live leaderboard will be plugged</Text>
              </Grid>
            )
          }
          {
            tweet?.ghostwriterTwUserName && (
              <Flex flexDir="column">
                <Grid gridTemplateColumns={"16px 1fr"} alignItems="center" justifyContent="left" textStyle="body.medium.light">
                  <SiGhostery />
                  <Text ml="2">Written by <Link href={"https://twitter.com/" + tweet?.ghostwriterTwUserName}>@{tweet?.ghostwriterTwUserName}</Link></Text>
                </Grid>
                <Grid gridTemplateColumns={"16px 1fr"} alignItems="center" justifyContent="left" mt={4} textStyle="body.medium.light">
                  <BiTimeFive />
                  <Text ml="2">Pushed on {dateFormat(tweet.datePushedToCreator ? (tweet.datePushedToCreator?.toDate ? tweet.datePushedToCreator?.toDate() : new Date(tweet.datePushedToCreator?._seconds * 1000)) : (tweet.dateCreated?.toDate ? tweet.dateCreated?.toDate() : new Date(tweet.dateCreated?._seconds * 1000)), "yyyy-mm-dd HH:MM")}</Text>
                </Grid>
              </Flex>
            )
          }
          {
            tweet?.isPushTaplio && (
              <Grid gridTemplateColumns={"16px 1fr"} alignItems="center" justifyContent="left" textStyle="body.medium.light">
                <SiLinkedin />
                <Text ml="2">Will be {tweet.isScheduled ? "scheduled for Linkedin" : "published now on Linkedin"} with Taplio</Text>
              </Grid>
            )
          }
          {
            tweet?.isNotifyFanList && (
              <Grid gridTemplateColumns={"16px 1fr"} alignItems="center" justifyContent="left" textStyle="body.medium.light">
                <AiOutlineBell />
                <Text ml="2">Your subscribers will be notified by email</Text>
              </Grid>
            )
          }
          {
            selectedLabels?.length > 0 && (
              <Box>
                <Text textStyle="body.medium.light">Labels linked to this tweet:</Text>
                <Wrap spacing="2" mt="2">
                  {
                    selectedLabels.map((label, index) => (
                      <WrapItem key={"label-" + index}>
                        <Tag color="white" bg={label.color + ".500"} fontWeight="normal">{label.title}</Tag>
                      </WrapItem>
                    )
                    )}
                </Wrap>
              </Box>
            )
          }
        </Stack>
      )
    else
      return (
        <>
        </>
      )
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      w="100%"
      maxW={rest.maxW ?? "400px"}
      alignItems="center"
    >
      <VStack
        w="100%"
        // maxW="400px"
        spacing={0}
        p={mode == "blog" ? "0" : "4"}
        m={showOutline ? 2 : 0}
        border={showOutline ? "solid 1px " + useColorModeValue(theme.colors.gray[200], theme.colors.gray[600]) : "none"}
        rounded={showOutline ? "lg" : "0"}
      >
        {
          threadTweets?.map((tweet, index) => (
            <Box key={index} w="100%">
              <ThreadTweet
                name={name ?? getAccount(session)?.name}
                image={image ?? getAccount(session)?.image}
                text={typeof tweet == "string" ? tweet : tweet.text}
                tweet={typeof tweet == "string" ? {} : tweet}
                isLast={index == threadTweets?.length - 1}
                isNotThread={threadTweets?.length === 1}
                index={index}
                mode={mode}
                disablePreview={disablePreview}
                selectTweetInThread={selectTweetInThread}
                showGenerateImage={showGenerateImage}
                {...rest}
              />
            </Box>
          ))
        }
      </VStack>
      {
        tweet !== undefined && (
          buildReminders()
        )
      }
    </Box>
  );
};

export default Tweet;
